import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { isEmpty, updateBodyScroll } from "../../utils";
import { AdService } from "../ad-service";
import { AdSlotRow } from "../collection-templates/ad-slot-row";
import { CustomWidgetRow } from "../collection-templates/custom-widget-row";

class HeaderBase extends React.Component {
  toggleSidebar = () => {
    updateBodyScroll(!this.props.header.isSidebarVisible, "remove-body-scroll-header");
    this.props.toggleSidebar();
  };

  closeAll = () => {
    updateBodyScroll(false, "remove-body-scroll-header");
    this.props.closeAll();
  };

  windowScroll = () => {
    window.scrollTo(0, 0);
  };

  renderHeader = () =>
    this.props.renderTemplate(
      Object.assign({}, this.props, this.state),
      this.toggleSidebar,
      this.props.toggleSearchForm,
      this.props.hideSearchForm,
      this.closeAll,
      this.windowScroll,
      this.props.headerSecondaryLogo,
      this.props.enableSSO,
      this.props.enableAccesstype,
      this.props.socialFollowStyle
    );

  renderHeaderRows = () => {
    const headerRowsList = get(this.props, ["pageBuilderConfig", "header", "rows"], []);
    return headerRowsList.map(row => {
      switch (row.type) {
        case "header":
          return this.renderHeader();
        case "widget":
          return <CustomWidgetRow metadata={row} />;
        case "ads":
          return <AdSlotRow metadata={row} />;
      }
    });
  };

  render() {
    if (isEmpty(this.props.pageBuilderConfig)) {
      return (
        <>
          <div className="app-ad app-ad--leaderboard">
            <AdService adtype="Horizontal-Ad" layoutName="Navigation" slotId="Horizontal-Ad-Above-Header" />
          </div>
          {this.renderHeader()}
        </>
      );
    }
    if (this.props.showHeaderRowOnly) return this.renderHeader();
    return this.renderHeaderRows();
  }
}

const mapStateToProps = state => {
  return {
    title: get(state.qt, ["config", "publisher-settings", "title"], "Madrid"),
    menu: get(state.qt, ["data", "navigationMenu"], []),
    publisherTheme: get(state.qt, ["config", "theme-attributes"], {}),
    pageBuilderConfig: get(state.qt, ["config", "pagebuilder-config"], {}),
    publisherName: get(state.qt, ["config", "publisher-name"], "Madrid"),
    socialLinks: get(state.qt, ["config", "social-links"], {}),
    header: state.header || {},
    currentPath: state.qt.currentPath,
    enableSSO: get(
      state.qt,
      ["config", "pagebuilder-config", "header", "enableSSO"],
      get(state.qt, ["config", "theme-attributes", "enableSSO"], false)
    ),
    member: get(state, ["member"], null),
    isLoginOpen: get(state, ["isLoginOpen"], false),
    headerSecondaryLogo: get(
      state.qt,
      ["config", "pagebuilder-config", "header", "logo"],
      get(state.qt, ["config", "theme-attributes", "secondary_logo"], "")
    ),
    enableAccesstype: get(
      state.qt,
      ["config", "pagebuilder-config", "header", "enableSubscriptionButton"],
      get(state.qt, ["config", "theme-attributes", "enableAccesstype"], false)
    ),
    socialFollowStyle: get(
      state.qt,
      ["config", "pagebuilder-config", "header", "socialFollowStyle"],
      "circular-color-svg"
    ),
    primaryLogo: get(
      state.qt,
      ["config", "pagebuilder-config", "header", "logoOnScroll"],
      get(state.qt, ["config", "theme-attributes", "primary_logo"], "")
    )
  };
};

const mapDispatchToProps = dispatch => ({
  openLoginTemplate: () => dispatch({ type: "OPEN_LOGIN_TEMPLATE" }),
  closeLoginTemplate: () => dispatch({ type: "CLOSE_LOGIN_TEMPLATE" }),
  toggleSidebar: () => dispatch({ type: "TOGGLE_SIDEBAR_MENU" }),
  hideSearchForm: () => dispatch({ type: "CLOSE_SEARCHFORM" }),
  toggleSearchForm: () => dispatch({ type: "TOGGLE_SEARCHFORM" }),
  closeAll: () => dispatch({ type: "CLOSE_ALL" })
});

HeaderBase.propTypes = {
  title: PropTypes.string,
  menu: PropTypes.array,
  enableSSO: PropTypes.bool,
  enableAccesstype: PropTypes.bool,
  socialFollowStyle: PropTypes.string,
  publisherTheme: PropTypes.shape({
    logo: PropTypes.string,
    monogram: PropTypes.string,
    header_theme: PropTypes.string
  }),
  pageBuilderConfig: PropTypes.shape({
    logo: PropTypes.string,
    monogram: PropTypes.string,
    header_theme: PropTypes.string
  }),
  publisherName: PropTypes.string,
  socialLinks: PropTypes.shape({
    "facebook-url": PropTypes.string,
    "twitter-url": PropTypes.string
  }),
  header: PropTypes.shape({
    isSidebarVisible: PropTypes.bool,
    isSearchFormVisible: PropTypes.bool
  }),
  currentPath: PropTypes.string,
  toggleSidebar: PropTypes.func,
  hideSearchForm: PropTypes.func,
  toggleSearchForm: PropTypes.func,
  headerSecondaryLogo: PropTypes.string,
  openPrimarySubmenu: PropTypes.func,
  closePrimarySubmenu: PropTypes.func,
  closeAll: PropTypes.func,
  renderTemplate: PropTypes.func,
  showHeaderRowOnly: PropTypes.bool
};

const Header = connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderBase);

export { Header };
